
<div class="position-relative h-100">
    <!-- Loading Circle -->
    <cv-loader [overlay]="true" [hidden]="!loading"></cv-loader>

    <!-- No Dashboard Selected -->
    <div *ngIf="selectedDashboards.length === 0" class="h-100 d-flex justify-content-center">
        <div class="align-self-center font-size-18 text-center color-valyrianSteel">
            <div *ngIf="!useTemplateCopy" cvLocalizedText langSection="Left_Nav_Popup" langKey="No_Dashboard">No Dashboard</div>
            <div *ngIf="useTemplateCopy" cvLocalizedText langSection="Templates" langKey="No_Template">No Template</div>
            <div cvLocalizedText langSection="Left_Nav_Popup" langKey="Selected">Selected</div>
        </div>
    </div>

    <!-- Dashboard Selected -->
    <div *ngIf="selectedDashboards?.length > 0 && !loading" class="w-100">
        <ngb-carousel [interval]="-1" [wrap]="true" [showNavigationArrows]="false" [showNavigationIndicators]="false" #carousel="ngbCarousel">
            <ng-template ngbSlide *ngFor="let dashboard of selectedDashboards; let $index = index" (slid)="onSlide($index, $event)">
                <!-- Dashboard Preview -->
                <gridster class="dashboard-preview-gridster" [options]="previewGridOpts" #gridster>
                    <gridster-item class="gridster-item" *ngFor="let item of modules.get(dashboard.DashboardKey)" [item]="item">
                        <!-- Module preview here -->
                        <div class="gridItem preview" [style.background-image]="'url(' + item.PreviewImagePath + ')'">
                            <!-- Module preview content here -->
                            <div class="gridItemPreviewLabelFader"></div>
                            <div class="gridItemPreviewLabel txtOverflow">
                                {{item.ModuleName}}
                            </div>
                        </div>
                    </gridster-item>
                </gridster>

                <!-- Dashboard Details -->
                <div class="mt-4 text-left">
                    <!-- View Editable Dashboard Details -->
                    <div *ngIf="!editDetails">
                        <h5 class="bold d-flex align-items-center text-nowrap font-size-18">
                            <div class="text-truncate" [class.font-italic]="!dashboard.DashboardName">
                                {{ dashboard.DashboardName || 'No Name'}}
                            </div>
                            <button *ngIf="canEdit(dashboard)" type="button" class="icon-btn ml-1" (click)="edit(dashboard.DashboardName, dashboard.DashboardDescription, dashboard.DashboardGroup)">
                                <svg class="icon-16 fill-valyrianSteel">
                                    <use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use>
                                </svg>
                            </button>
                        </h5>
                        <p class="m-0 pb-4" [class.font-italic]="!dashboard.DashboardDescription">
                            {{ dashboard.DashboardDescription || 'No Description' }}
                        </p>
                    </div>

                    <!-- Edit Editable Dashboard Details -->
                    <div *ngIf="editDetails">
                        <div class="mb-3">
                            <span cvLocalizedText langSection="Common" langKey="Name">Name</span>
                            <input type="text" maxlength="50" class="form-control" placeholder="Name" [(ngModel)]="dashboardName" />
                        </div>

                        <div class="mb-3">
                            <span cvLocalizedText langSection="Common" langKey="Description">Description</span>
                            <textarea class="form-control m-0 py-2" style="height: 100px; resize: none;" [(ngModel)]="dashboardDescription"></textarea>
                        </div>

                        <div class="d-flex justify-content-end">
                            <button type="button" class="btn btn-text mr-2" (click)="cancelEdit()">
                                <span cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</span>
                            </button>
                            <button type="button" class="btn btn-primary" (click)="applyEdit(dashboard)">
                                <span cvLocalizedText langSection="Common" langKey="Apply">Apply</span>
                            </button>
                        </div>
                    </div>

                    <!-- View Uneditable Dashboard Details -->
                    <ng-container [ngSwitch]="previewType">
                        <ng-container *ngSwitchCase="PreviewType.Dashboard">
                            <div class="d-flex body-2">
                                <p style="width: 110px">
                                    <span cvLocalizedText langSection="Dashboards_Landing" langKey="Created_by">Created by</span>:
                                </p>
                                <p [class.font-italic]="!dashboard.CreatedBy">{{ dashboard.CreatedBy || 'N/A' }}</p>
                            </div>
                            <div class="d-flex body-2">
                                <p style="width: 110px">
                                    <span cvLocalizedText langSection="Dashboards_Landing" langKey="Last_Modified_by">Last Modified by</span>:
                                </p>
                                <p [class.font-italic]="!dashboard.ModifiedBy">{{ dashboard.ModifiedBy || 'N/A' }}</p>
                            </div>
                            <div class="d-flex body-2">
                                <p style="width: 110px">
                                    <span cvLocalizedText langSection="Dashboards_Landing" langKey="Shared_to">Shared to</span>:
                                </p>
                                <p>
                                    <button type="button" class="btn-text p-0" [disabled]="!canShare(dashboard)" (click)="openAssignTool.emit(dashboard)">
                                        {{ dashboard.NumRecipientLogins || 0 }} <span cvLocalizedText langSection="Dashboards_Landing" langKey="Users">users</span>
                                    </button>
                                </p>
                            </div>
                            <p *ngIf="dashboard.SharedBy" class="mt-3 caption color-valyrianSteel">
                                <span cvLocalizedText langSection="Dashboards_Landing" langKey="Shared_by">Shared by</span> {{dashboard.SharedBy}}
                            </p>
                        </ng-container>
                        <ng-container *ngSwitchCase="PreviewType.SharedTemplate">
                            <div class="d-flex body-2">
                                <p style="width: 110px">
                                    <span cvLocalizedText langSection="Templates" langKey="Last_Modified">Last Modified:</span>
                                </p>
                                <p>{{ sharedTemplate.LastModifiedDate | date: cvLocalizedDateFormat || 'N/A' }}</p>
                            </div>
                            <div class="d-flex body-2">
                                <p style="width: 110px">
                                    <span cvLocalizedText langSection="Templates" langKey="Modified_By">Modified By:</span>
                                </p>
                                <p>{{ sharedTemplate.ModifiedBy || 'N/A' }}</p>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="PreviewType.SystemTemplate">
                            <div class="d-flex body-2">
                                <p style="width: 110px">
                                    <span cvLocalizedText langSection="Templates" langKey="Last_Used">Last Used:</span>
                                </p>
                                <p>{{ systemTemplate.LastUsedDate | date: cvLocalizedDateFormat || 'N/A' }}</p>
                            </div>
                            <div class="d-flex body-2">
                                <p style="width: 110px">
                                    <span cvLocalizedText langSection="Templates" langKey="Last_Modified">Last_Modified</span>
                                </p>
                                <p>{{ systemTemplate.LastModifiedDate | date: cvLocalizedDateFormat || 'N/A' }}</p>
                            </div>
                            <div class="d-flex body-2">
                                <p style="width: 110px">
                                    <span cvLocalizedText langSection="Templates" langKey="Group">Group:</span>
                                </p>
                                <p>{{ systemTemplate.SystemTemplateGroup }}</p>
                            </div>
                            <div class="d-flex body-2" *ngIf="hasTemplateAdminAccess">
                                <p style="width: 110px">
                                    <span cvLocalizedText langSection="Templates" langKey="PersonaID">PersonaID:</span>
                                </p>
                                <p>{{ systemTemplate.Personas }}</p>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-template>
        </ngb-carousel>
        <div class="carousel-controls">
            <a href class="carousel-control-prev" style="height: 210px; z-index: 2000;" (click)="carousel.prev()" [hidden]="selectedDashboards.length <= 1">
                <svg class="icon-24">
                    <use href="../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use>
                </svg>
            </a>
            <a href class="carousel-control-next" style="height: 210px; z-index: 2000;" (click)="carousel.next()" [hidden]="selectedDashboards.length <= 1">
                <svg class="icon-24">
                    <use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use>
                </svg>
            </a>
        </div>
    </div>
</div>
